import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { PageHeader, Inquiries, GradientFallback } from '../Globals';

function MediaSorting(props) {
  const today = new Date().toISOString().substring(0, 10);
  let media = props.media.filter(event => event.date <= today);
  media = media.filter(event => event.program !== "BIG BANG Tech Report");
  media = media.sort((a, b) => new Date(b.date) -  new Date(a.date));

  const mediaCards = media.map((media, i) => <MediaCard name={media.name} date={media.date} type={media.type} program={media.program} host={media.host}  description={media.description} image={media.image} link={media.link} key={i} />);

  return(
    <>
      <div className="px-5 mb-5">
        <div className="col-12 my-auto">
          <div className="row d-flex justify-content-center mx-1">
            {mediaCards}
          </div>
        </div>
      </div>
    </>
  );
}

export function MediaCard(props) {
  return (
    <Card className="col-12 col-md-5 px-0 m-1 m-md-3">
      <Card.Header className="text-center py-1">
        <h2 className=" mb-0">{props.program}</h2>
        <p className="subhead mb-0 text-muted">{props.host}</p>
      </Card.Header>
      <Card.Body
        as={props.link ? "a" : "div"}
        href={props.link || undefined} target={props.link ? "_blank" : undefined}
        rel={props.link ? "noopener noreferrer" : undefined}
        className="px-3 py-3 d-flex flex-column justify-content-center"
      >
        {props.image ? <Card.Img variant="middle" src={props.image}
          className="bg-light" style={{ maxWidth: "100%", maxHeight: "270px", objectFit: "contain" }}
        />
        : <GradientFallback type={props.type} />}
        <Card.Title as="h5" className="my-2">
          {props.name}
        </Card.Title>
        <Card.Subtitle as="p" className="text-muted small mb-2">
          <em>{props.type} &ensp;·&ensp; {props.date}</em>
        </Card.Subtitle>
        <Card.Text className="text-muted small flex-grow-1 desc-trunc">
          {props.description}
        </Card.Text>
          {props.link && <Button as="a" href={props.link} target="_blank" rel="noopener noreferrer" variant="secondary" className="bg-blue">Open {props.type}</Button>}
      </Card.Body>
    </Card>
  );
}

export default function Media(props) {
  const pageTitle = "Press & Media";
  const pageDescription = <span>See other activity related to <em>Our Next Reality</em></span>;
  
  return (
    <main>
      <div className="container pt-4">
        <div className="row d-flex justify-content-center">
          <PageHeader title={pageTitle} description={pageDescription}/>
          <Inquiries hide="" />
          {props.isFetching ? '' : <MediaSorting media={props.media} />}
        </div>
      </div>
    </main>
  );
}
